import route_list from "./routeUrl"

const pixleBlacklistRoute = [route_list.login, route_list.register, route_list.otp, route_list.help_center, route_list.userNotification]

export {
  pixleBlacklistRoute
}